





import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    props: {
        isUsedContainerClass: {
            type: Boolean,
            default: true,
        },
    },
});
